/**
 * /logistica/* — router-shell do modulo Logistica (Fase 11).
 *
 * Sub-rotas:
 *   /logistica/cargas (default) -> Lista de Cargas + agenda
 *   /logistica/cargas/criar -> Criar Carga
 *   /logistica/cargas/:id -> Detalhe da Carga + actions
 *   /logistica/entregas -> Lista de OEs
 *   /logistica/entregas/:id -> Detalhe da OE
 *   /logistica/instalacoes -> Lista de OIs
 *   /logistica/instalacoes/:id -> Detalhe da OI
 *   /logistica/cadastros -> CRUD Motoristas + Veiculos + Equipes
 */
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import CargasLista from "./Cargas/Lista";
import CargaDetalhe from "./Cargas/Detalhe";
import CargaCriar from "./Cargas/Criar";
import EntregasLista from "./Entregas/Lista";
import EntregaDetalhe from "./Entregas/Detalhe";
import InstalacoesLista from "./Instalacoes/Lista";
import InstalacaoDetalhe from "./Instalacoes/Detalhe";
import Cadastros from "./Cadastros";
import ConfiguracaoRoteirizacao from "./Configuracao";

export default function LogisticaShell() {
  return (
    <Routes>
      <Route index element={<Navigate to="cargas" replace />} />
      <Route path="cargas" element={<CargasLista />} />
      <Route path="cargas/criar" element={<CargaCriar />} />
      <Route path="cargas/:id" element={<CargaDetalhe />} />
      <Route path="entregas" element={<EntregasLista />} />
      <Route path="entregas/:id" element={<EntregaDetalhe />} />
      <Route path="instalacoes" element={<InstalacoesLista />} />
      <Route path="instalacoes/:id" element={<InstalacaoDetalhe />} />
      <Route path="cadastros/*" element={<Cadastros />} />
      <Route path="configuracao" element={<ConfiguracaoRoteirizacao />} />
      <Route path="*" element={<Navigate to="cargas" replace />} />
    </Routes>
  );
}
